import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Typography } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import styles from "@/styles/ThreadPreview.module.less";
const { Text } = Typography;
/** Russian pluralization: 1 ответ, 2 ответа, 5 ответов, 21 ответ, 22 ответа */
function pluralizeRu(n, one, few, many) {
    const mod100 = Math.abs(n) % 100;
    const mod10 = mod100 % 10;
    if (mod100 >= 11 && mod100 <= 19)
        return many;
    if (mod10 === 1)
        return one;
    if (mod10 >= 2 && mod10 <= 4)
        return few;
    return many;
}
/** Extract order number like "PZ-XXXX" from message text */
function extractOrderNumber(text) {
    const match = text.match(/PZ-\d+/);
    return match ? match[0] : null;
}
const ThreadPreview = observer(({ rootPost, replyCount, onClick }) => {
    const orderNumber = extractOrderNumber(rootPost.message);
    const title = orderNumber
        ? `Чат с клиентом по ${orderNumber}`
        : "Обсуждение";
    return (_jsx("div", { className: styles.container, onClick: onClick, children: _jsx(Card, { size: "small", className: styles.card, hoverable: true, children: _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.titleRow, children: [_jsx(CommentOutlined, { className: styles.icon }), _jsx(Text, { strong: true, className: styles.title, children: title })] }), _jsx("div", { className: styles.meta, children: _jsxs(Text, { type: "secondary", className: styles.replyCount, children: [replyCount, " ", pluralizeRu(replyCount, "ответ", "ответа", "ответов")] }) })] }) }) }));
});
ThreadPreview.displayName = "ThreadPreview";
export default ThreadPreview;
